<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
        </div>
        <el-button size="small" type="primary" @click="dialog()" v-if="$isPerm('doc-expenseClaim-save')">添加档案</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="bill_date" label="日期" width="120"> </el-table-column>
      <el-table-column prop="name" label="名称" width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="employee_name" label="业务员" width="120"> </el-table-column>
      <el-table-column prop="customer_name" label="客户" width="120" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="amount" label="金额" width="80"> </el-table-column>
      <el-table-column prop="cost" label="成本" width="80"> </el-table-column>
      <el-table-column prop="deposit" label="定金" width="80"> </el-table-column>
      <el-table-column prop="is_refund" label="是否退款" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.is_refund ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.create_employee_name }} {{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.update_employee_id > 0">{{ scope.row.update_employee_name }} {{ scope.row.update_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="info" @click="dialog(scope.row, true)" v-if="$isPerm('doc-expenseClaim-info')">查看</el-button>
          <el-button size="mini" type="success" @click="dialog(scope.row)" v-if="$isPerm('doc-expenseClaim-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('doc-expenseClaim-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <doc-save ref="docSaveRef" @callMethod="refresh" :isView="isView"></doc-save>
    </el-dialog>
  </div>
</template>

<script>
import docSave from '@/components/doc/receipt';
export default {
  name: 'docList',
  components: {
    docSave
  },
  created() {
    this.getData();
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      loading: false,
      isView: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: ''
      }
    };
  },
  methods: {
    //新增/编辑
    dialog(row, isView = false) {
      this.isView = isView;
      this.dialogShow = true;
      this.dialogTitle = '添加回款档案';
      this.formData = {
        id: 0,
        title: '',
        content: '',
        top: 0
      };
      if (row) {
        this.dialogTitle = isView ? '查看回款档案' : '编辑回款档案';
        this.$nextTick(() => {
          this.$refs.docSaveRef.setData(row.id);
        });
      }
    },
    //删除
    async deleteData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.loading = true;
          await this.$api.docReceipt.delete({ id }).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      await this.$api.docReceipt.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.getData();
      this.dialogShow = false;
    }
  }
};
</script>
